import { PasswordRecoveryComponent } from './../components/password-recovery/password-recovery.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PasswordRecoveryService {
  constructor(public dialog: MatDialog) {}

  openModal(options: MatDialogConfig = {}) {
    let options_config: MatDialogConfig = { panelClass: 'password-recovery-dialog', ...options };
    return this.dialog.open(PasswordRecoveryComponent, options_config);
  }
}
